// extracted by mini-css-extract-plugin
export var addendum = "Addendum-module--addendum--11iAE";